/**
 * A function to create a log object for the 'exploreResultsPageGenericClick' event (evid: 1001)
 *
 * Event description: user clicks on one of the buttons in the explore partners results page
 *
 * @param {exploreResultsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - users entry to explore
 * @property {string} data - the data extracted from the click
 * @property {string} clickType - view partners profile/sort ect.
 * @property {string} exploreVersion - {version1/version2 ect.}
 * @property {string} origin - users origin to explore
 * @property {GUID} sessionId - users session in the explore
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<exploreResultsPageGenericClickParams>} LogObject<exploreResultsPageGenericClickParams>
 */
export function exploreResultsPageGenericClick(params) {
    return { evid: 1001, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'copyOfExploreResultsPageGenericClick' event (evid: 1002)
 *
 * Event description: user clicks on one of the buttons in the explore partners results page
 *
 * @param {copyOfExploreResultsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - users entry to explore
 * @property {string} data - the data extracted from the click
 * @property {string} clickType - view partners profile/sort ect.
 * @property {string} exploreVersion - {version1/version2 ect.}
 * @property {string} origin - users origin to explore
 * @property {GUID} sessionId - session id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} inMarketplace - is partner in the marketplace?
 * @return {LogObject<copyOfExploreResultsPageGenericClickParams>} LogObject<copyOfExploreResultsPageGenericClickParams>
 */
export function copyOfExploreResultsPageGenericClick(params) {
    return { evid: 1002, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'partnersProfilePagePageLoaded' event (evid: 1003)
 *
 * Event description: Fires when the a partners profile page is loaded
 *
 * @param {partnersProfilePagePageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} entry - users entry to explore
 * @property {string} provider_id - the partners guid
 * @property {string} exploreVersion - {version1/version2 ect.}
 * @property {string} origin - users origin to explore
 * @property {GUID} sessionId - session id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} inMarketplace - is partner in the marketplace?
 * @return {LogObject<partnersProfilePagePageLoadedParams>} LogObject<partnersProfilePagePageLoadedParams>
 */
export function partnersProfilePagePageLoaded(params) {
    return { evid: 1003, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceHeaderClientGenericClick' event (evid: 1005)
 *
 * Event description: Click on MP Header - Client events
 *
 * @param {marketplaceHeaderClientGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - data extracted from the click
 * @property {string} clickType - Name of the button clicked
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} pageName - name of page
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceHeaderClientGenericClickParams>} LogObject<marketplaceHeaderClientGenericClickParams>
 */
export function marketplaceHeaderClientGenericClick(params) {
    return { evid: 1005, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProjectsDashboardGenericClick' event (evid: 1006)
 *
 * Event description: Generic click in the marketplace projects in partners dashboard
 *
 * @param {marketplaceProjectsDashboardGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - data extracted
 * @property {string} data - data extracted
 * @property {string} device_type_dev - device type
 * @property {string} clickType - type of click
 * @property {string} job_id - job id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectsDashboardGenericClickParams>} LogObject<marketplaceProjectsDashboardGenericClickParams>
 */
export function marketplaceProjectsDashboardGenericClick(params) {
    return { evid: 1006, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProjectsDashboardLoadPage' event (evid: 1007)
 *
 * Event description: load page event for the marketplace projects dashboard
 *
 * @param {marketplaceProjectsDashboardLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} platform - The platform the user is using (wix.com/Studio)
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectsDashboardLoadPageParams>} LogObject<marketplaceProjectsDashboardLoadPageParams>
 */
export function marketplaceProjectsDashboardLoadPage(params) {
    return { evid: 1007, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProjectsDashboardGenericClickMobile' event (evid: 1009)
 *
 * Event description: Generic click in the marketplace projects in partners dashboard
 *
 * @param {marketplaceProjectsDashboardGenericClickMobileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - click data
 * @property {string} clickType - type of click
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectsDashboardGenericClickMobileParams>} LogObject<marketplaceProjectsDashboardGenericClickMobileParams>
 */
export function marketplaceProjectsDashboardGenericClickMobile(params) {
    return { evid: 1009, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProjectPageLoadPage' event (evid: 1011)
 *
 * Event description: load page event for a marketplace project page
 *
 * @param {marketplaceProjectPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectPageLoadPageParams>} LogObject<marketplaceProjectPageLoadPageParams>
 */
export function marketplaceProjectPageLoadPage(params) {
    return { evid: 1011, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProjectPageGenericClick' event (evid: 1012)
 *
 * Event description: Generic click in the marketplace projects in partners dashboard
 *
 * @param {marketplaceProjectPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} clickType - type of click
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectPageGenericClickParams>} LogObject<marketplaceProjectPageGenericClickParams>
 */
export function marketplaceProjectPageGenericClick(params) {
    return { evid: 1012, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProjectPageMassage' event (evid: 1013)
 *
 * Event description: fires every time a warning is sent in the marketplace projects dashboard
 *
 * @param {marketplaceProjectPageMassageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} message_type - message type that sen
 * @property {string} job_id - project's job id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProjectPageMassageParams>} LogObject<marketplaceProjectPageMassageParams>
 */
export function marketplaceProjectPageMassage(params) {
    return { evid: 1013, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceClientSMyProjectsPageLoadPage' event (evid: 1014)
 *
 * Event description: load page event for the client project dashboard page
 *
 * @param {marketplaceClientSMyProjectsPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSMyProjectsPageLoadPageParams>} LogObject<marketplaceClientSMyProjectsPageLoadPageParams>
 */
export function marketplaceClientSMyProjectsPageLoadPage(params) {
    return { evid: 1014, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceClientSMyProjectsPageGenericClick' event (evid: 1015)
 *
 * Event description: Generic click in the marketplace projects in client's dashboard
 *
 * @param {marketplaceClientSMyProjectsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} device_type_dev - device type
 * @property {string} clickType - type of click
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSMyProjectsPageGenericClickParams>} LogObject<marketplaceClientSMyProjectsPageGenericClickParams>
 */
export function marketplaceClientSMyProjectsPageGenericClick(params) {
    return { evid: 1015, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceClientSProjectsPageGenericClick' event (evid: 1016)
 *
 * Event description: Generic click in the marketplace in a client's project place
 *
 * @param {marketplaceClientSProjectsPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} device_type_dev - device type
 * @property {string} clickType - type of click
 * @property {string} job_id - job id of the project
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSProjectsPageGenericClickParams>} LogObject<marketplaceClientSProjectsPageGenericClickParams>
 */
export function marketplaceClientSProjectsPageGenericClick(params) {
    return { evid: 1016, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceClientSProjectPageLoadPage' event (evid: 1017)
 *
 * Event description: load page event for the client project dashboard page
 *
 * @param {marketplaceClientSProjectPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceClientSProjectPageLoadPageParams>} LogObject<marketplaceClientSProjectPageLoadPageParams>
 */
export function marketplaceClientSProjectPageLoadPage(params) {
    return { evid: 1017, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'wixStudioCustomTemplatesPageGenericClick' event (evid: 1019)
 *
 * Event description: Generic click event in the custom templates page
 *
 * @param {wixStudioCustomTemplatesPageGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - the data generated from the click
 * @property {string} click_type - type of click
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} template_id - the ID of the template
 * @return {LogObject<wixStudioCustomTemplatesPageGenericClickParams>} LogObject<wixStudioCustomTemplatesPageGenericClickParams>
 */
export function wixStudioCustomTemplatesPageGenericClick(params) {
    return { evid: 1019, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'wixStudioMyAppsPageLoadPage' event (evid: 1021)
 *
 * Event description: load page event for the my apps page
 *
 * @param {wixStudioMyAppsPageLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioMyAppsPageLoadPageParams>} LogObject<wixStudioMyAppsPageLoadPageParams>
 */
export function wixStudioMyAppsPageLoadPage(params) {
    return { evid: 1021, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'wixStudioDiscoverPageVideoAutoPlay' event (evid: 1024)
 *
 * Event description: new video start with auto-play after the previous ended
 *
 * @param {wixStudioDiscoverPageVideoAutoPlayParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} user_funnel_stage - new/returning/existing
 * @property {string} device_type_dev - user's device type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<wixStudioDiscoverPageVideoAutoPlayParams>} LogObject<wixStudioDiscoverPageVideoAutoPlayParams>
 */
export function wixStudioDiscoverPageVideoAutoPlay(params) {
    return { evid: 1024, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceOverviewDashboardGenericClick' event (evid: 1027)
 *
 * Event description: Generic click in the marketplace overview in partners dashboard
 *
 * @param {marketplaceOverviewDashboardGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_data - data extracted
 * @property {string} clickType - type of click
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} platform - The platform the user is using
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceOverviewDashboardGenericClickParams>} LogObject<marketplaceOverviewDashboardGenericClickParams>
 */
export function marketplaceOverviewDashboardGenericClick(params) {
    return { evid: 1027, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceProfileEditClickOnViewMyProfile' event (evid: 1028)
 *
 * Event description: When the partner clicks on 'view my profile' in his profile page
 *
 * @param {marketplaceProfileEditClickOnViewMyProfileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} click_type - click type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceProfileEditClickOnViewMyProfileParams>} LogObject<marketplaceProfileEditClickOnViewMyProfileParams>
 */
export function marketplaceProfileEditClickOnViewMyProfile(params) {
    return { evid: 1028, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'looksLikeSpamInExpertDashboard' event (evid: 111)
 *
 * Event description: press 'looks like spam' in expert dashboard
 *
 * @param {looksLikeSpamInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<looksLikeSpamInExpertDashboardParams>} LogObject<looksLikeSpamInExpertDashboardParams>
 */
export function looksLikeSpamInExpertDashboard(params) {
    return { evid: 111, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'cancelProjectInExpertDashboardDialogBox' event (evid: 112)
 *
 * Event description: press 'cancel project' in expert dashboard (not interested in project) dialog box
 *
 * @param {cancelProjectInExpertDashboardDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<cancelProjectInExpertDashboardDialogBoxParams>} LogObject<cancelProjectInExpertDashboardDialogBoxParams>
 */
export function cancelProjectInExpertDashboardDialogBox(params) {
    return { evid: 112, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'clientDeclinedInExpertDashboard' event (evid: 113)
 *
 * Event description: press 'Client declined' in expert dashboard
 *
 * @param {clientDeclinedInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientDeclinedInExpertDashboardParams>} LogObject<clientDeclinedInExpertDashboardParams>
 */
export function clientDeclinedInExpertDashboard(params) {
    return { evid: 113, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'approveDialogClientDeclinedInExpertDashboard' event (evid: 114)
 *
 * Event description: press 'cancel project' in expert dashboard (client declined) dialog box
 *
 * @param {approveDialogClientDeclinedInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} dialogType - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<approveDialogClientDeclinedInExpertDashboardParams>} LogObject<approveDialogClientDeclinedInExpertDashboardParams>
 */
export function approveDialogClientDeclinedInExpertDashboard(params) {
    return { evid: 114, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'submitProjectInExpertDashboard' event (evid: 115)
 *
 * Event description: press 'submit project' in expert dashboard
 *
 * @param {submitProjectInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part,dashboard,non_arena}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitProjectInExpertDashboardParams>} LogObject<submitProjectInExpertDashboardParams>
 */
export function submitProjectInExpertDashboard(params) {
    return { evid: 115, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'submitProjectInExpertDashboardDialogBox' event (evid: 116)
 *
 * Event description: press 'submit project' in expert dashboard dialog box. actual submit
 *
 * @param {submitProjectInExpertDashboardDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} websiteUrl - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitProjectInExpertDashboardDialogBoxParams>} LogObject<submitProjectInExpertDashboardDialogBoxParams>
 */
export function submitProjectInExpertDashboardDialogBox(params) {
    return { evid: 116, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'dashboardLoaded' event (evid: 118)
 *
 * Event description: Expert dashboard loaded
 *
 * @param {dashboardLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} numberOfItems - {number of briefs shown}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<dashboardLoadedParams>} LogObject<dashboardLoadedParams>
 */
export function dashboardLoaded(params) {
    return { evid: 118, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'aboutUsButtonClick' event (evid: 12)
 *
 * Event description: how it works header button was clicked
 *
 * @param {aboutUsButtonClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} isPro - is_pro
 * @return {LogObject<aboutUsButtonClickParams>} LogObject<aboutUsButtonClickParams>
 */
export function aboutUsButtonClick(params) {
    return { evid: 12, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'missingParameterInExpertDashboardFlow' event (evid: 122)
 *
 * Event description: validation false due to missing value. sent only when show error msg
 *
 * @param {missingParameterInExpertDashboardFlowParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {dialog name}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} value - {the missing parameter  or field}
 * @return {LogObject<missingParameterInExpertDashboardFlowParams>} LogObject<missingParameterInExpertDashboardFlowParams>
 */
export function missingParameterInExpertDashboardFlow(params) {
    return { evid: 122, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressEmailOfClientInExpertDashboard' event (evid: 123)
 *
 * Event description: press email of client in expert dashboard
 *
 * @param {pressEmailOfClientInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressEmailOfClientInExpertDashboardParams>} LogObject<pressEmailOfClientInExpertDashboardParams>
 */
export function pressEmailOfClientInExpertDashboard(params) {
    return { evid: 123, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressPhoneOfClientInExpertDashboard' event (evid: 124)
 *
 * Event description: press phone of client in expert dashboard (mobile only)
 *
 * @param {pressPhoneOfClientInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressPhoneOfClientInExpertDashboardParams>} LogObject<pressPhoneOfClientInExpertDashboardParams>
 */
export function pressPhoneOfClientInExpertDashboard(params) {
    return { evid: 124, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertDashboardFilterBriefs' event (evid: 125)
 *
 * Event description: changing the filter showing the briefs
 *
 * @param {expertDashboardFilterBriefsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {filter name: unread,expired..}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - leads tab/projects
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertDashboardFilterBriefsParams>} LogObject<expertDashboardFilterBriefsParams>
 */
export function expertDashboardFilterBriefs(params) {
    return { evid: 125, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertDashboardPressViewDetails' event (evid: 126)
 *
 * Event description: press to see the brief from dashboard
 *
 * @param {expertDashboardPressViewDetailsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {filter name: unread,expired..}
 * @property {string} button_name - {view_details,row}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - leads tab/ projects tab
 * @property {string} status - {status of job}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertDashboardPressViewDetailsParams>} LogObject<expertDashboardPressViewDetailsParams>
 */
export function expertDashboardPressViewDetails(params) {
    return { evid: 126, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'looksLikeSpamDialogBox' event (evid: 127)
 *
 * Event description: press 'cancel project' in expert dashboard (not interested in project) dialog box due to spam
 *
 * @param {looksLikeSpamDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<looksLikeSpamDialogBoxParams>} LogObject<looksLikeSpamDialogBoxParams>
 */
export function looksLikeSpamDialogBox(params) {
    return { evid: 127, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'clientCancelDialogBox' event (evid: 128)
 *
 * Event description: press 'cancel project' in expert dashboard (not interested in project) dialog box due to client cancel
 *
 * @param {clientCancelDialogBoxParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} reason - {}
 * @property {string} origin - {top_part; bottom_part}
 * @property {string} details - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clientCancelDialogBoxParams>} LogObject<clientCancelDialogBoxParams>
 */
export function clientCancelDialogBox(params) {
    return { evid: 128, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'reportReview' event (evid: 129)
 *
 * Event description: expert reports that the review is inappropriate
 *
 * @param {reportReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<reportReviewParams>} LogObject<reportReviewParams>
 */
export function reportReview(params) {
    return { evid: 129, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'supportButtonClick' event (evid: 13)
 *
 * Event description: Explore portfolios button was clicked (homepage)
 *
 * @param {supportButtonClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} isPro - is_pro
 * @return {LogObject<supportButtonClickParams>} LogObject<supportButtonClickParams>
 */
export function supportButtonClick(params) {
    return { evid: 13, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertPressesSubmitThisReview' event (evid: 130)
 *
 * Event description: expert reports that the review is inappropriate with the details
 *
 * @param {expertPressesSubmitThisReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {}
 * @return {LogObject<expertPressesSubmitThisReviewParams>} LogObject<expertPressesSubmitThisReviewParams>
 */
export function expertPressesSubmitThisReview(params) {
    return { evid: 130, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'provideFeedbackPageLoaded' event (evid: 131)
 *
 * Event description: provide feedback page loaded
 *
 * @param {provideFeedbackPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<provideFeedbackPageLoadedParams>} LogObject<provideFeedbackPageLoadedParams>
 */
export function provideFeedbackPageLoaded(params) {
    return { evid: 131, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'endUserSubmitReview' event (evid: 132)
 *
 * Event description: end user finishes his review to the expert
 *
 * @param {endUserSubmitReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {}
 * @return {LogObject<endUserSubmitReviewParams>} LogObject<endUserSubmitReviewParams>
 */
export function endUserSubmitReview(params) {
    return { evid: 132, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'thankYouPageForSubmittingReview' event (evid: 133)
 *
 * Event description: Thank you page for submitting review
 *
 * @param {thankYouPageForSubmittingReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<thankYouPageForSubmittingReviewParams>} LogObject<thankYouPageForSubmittingReviewParams>
 */
export function thankYouPageForSubmittingReview(params) {
    return { evid: 133, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'newBriefLoaded' event (evid: 135)
 *
 * Event description: step 0: what do you need done
 *
 * @param {newBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceid - {1;2; e.g. small fix; new website}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {support;SEO Wizard}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<newBriefLoadedParams>} LogObject<newBriefLoadedParams>
 */
export function newBriefLoaded(params) {
    return { evid: 135, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'stepsInNewBrief' event (evid: 136)
 *
 * Event description: step 1-10 in new brief
 *
 * @param {stepsInNewBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {number} serviceid - {1;2; e.g. small fix; new website}
 * @property {boolean} skip - if user skips screen
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {support;SEO Wizard}
 * @property {string} sessionId - {}
 * @property {string} category - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} jsonData - {json data}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} validation - {validating mandatory fields}
 * @return {LogObject<stepsInNewBriefParams>} LogObject<stepsInNewBriefParams>
 */
export function stepsInNewBrief(params) {
    return { evid: 136, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressingBackInNewBrief' event (evid: 137)
 *
 * Event description: press back
 *
 * @param {pressingBackInNewBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} nextScreenName - next screen
 * @return {LogObject<pressingBackInNewBriefParams>} LogObject<pressingBackInNewBriefParams>
 */
export function pressingBackInNewBrief(params) {
    return { evid: 137, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressingSkipInNewBrief' event (evid: 138)
 *
 * Event description: press skip
 *
 * @param {pressingSkipInNewBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow_version for testing
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressingSkipInNewBriefParams>} LogObject<pressingSkipInNewBriefParams>
 */
export function pressingSkipInNewBrief(params) {
    return { evid: 138, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'logInButtonClick' event (evid: 14)
 *
 * Event description: Log in button was clicked
 *
 * @param {logInButtonClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} isPro - is_pro
 * @return {LogObject<logInButtonClickParams>} LogObject<logInButtonClickParams>
 */
export function logInButtonClick(params) {
    return { evid: 14, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'innerBriefLoaded' event (evid: 140)
 *
 * Event description: Load the inner brief after the user chooses the service requested
 *
 * @param {innerBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - {1;2; e.g. small fix; new website}
 * @property {number} innerType - {1;2}
 * @property {string} entry - e.g, generalMenu, support_banner
 * @property {string} data - {}
 * @property {number} height - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {login}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - {}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<innerBriefLoadedParams>} LogObject<innerBriefLoadedParams>
 */
export function innerBriefLoaded(params) {
    return { evid: 140, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'explorePageZeroState' event (evid: 141)
 *
 * Event description: Fires when explore main page is loaded
 *
 * @param {explorePageZeroStateParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} location - not in use
 * @property {string} entry - user's entry point
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} exploreVersion - V1/V2 ect.
 * @property {string} language - not in use
 * @property {string} origin - The traffic source
 * @property {GUID} sessionId - users session id
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<explorePageZeroStateParams>} LogObject<explorePageZeroStateParams>
 */
export function explorePageZeroState(params) {
    return { evid: 141, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'explorePageApplyFilter' event (evid: 142)
 *
 * Event description: User applies a filter on the profile page
 *
 * @param {explorePageApplyFilterParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} filterValue - all the elements in the filter
 * @property {string} filterType - service / price / location ...
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<explorePageApplyFilterParams>} LogObject<explorePageApplyFilterParams>
 */
export function explorePageApplyFilter(params) {
    return { evid: 142, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'explorePageEmptyState' event (evid: 143)
 *
 * Event description: The explore page is loaded as an empty state (no experts were found)
 *
 * @param {explorePageEmptyStateParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {string} location - not in use
 * @property {string} filterValue - json with the filters
 * @property {number} innerType - not in use
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} language - not in use
 * @property {string} origin - Where the click came from
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<explorePageEmptyStateParams>} LogObject<explorePageEmptyStateParams>
 */
export function explorePageEmptyState(params) {
    return { evid: 143, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'profilePageClickOnShareProfile' event (evid: 145)
 *
 * Event description: User clicks on "share profile" on the expert profile page
 *
 * @param {profilePageClickOnShareProfileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider guid
 * @return {LogObject<profilePageClickOnShareProfileParams>} LogObject<profilePageClickOnShareProfileParams>
 */
export function profilePageClickOnShareProfile(params) {
    return { evid: 145, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'profilePageClickOnShowMoreProjects' event (evid: 147)
 *
 * Event description: User clicks on "show more projects" on the expert profile page
 *
 * @param {profilePageClickOnShowMoreProjectsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider guid
 * @return {LogObject<profilePageClickOnShowMoreProjectsParams>} LogObject<profilePageClickOnShowMoreProjectsParams>
 */
export function profilePageClickOnShowMoreProjects(params) {
    return { evid: 147, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'profilePageClickOnReadMore' event (evid: 148)
 *
 * Event description: User clicks on "read more" on the about me section in the expert profile page
 *
 * @param {profilePageClickOnReadMoreParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider guid
 * @return {LogObject<profilePageClickOnReadMoreParams>} LogObject<profilePageClickOnReadMoreParams>
 */
export function profilePageClickOnReadMore(params) {
    return { evid: 148, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'exploreLoadPage' event (evid: 15)
 *
 * Event description: The explore results page is loaded
 *
 * @param {exploreLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {string} partnerList - json with list of partners in the results page
 * @property {string} location - not in use
 * @property {GUID} visitorId - not in use
 * @property {string} filterValue - json with the filters
 * @property {number} innerType - not in use
 * @property {string} lng_dev - language
 * @property {string} entry - users entry point - the page
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} rankerVersion - the version of the ranker
 * @property {string} exploreVersion - V1/V2 ect.
 * @property {string} language - not in use
 * @property {string} origin - users entry point - the click the user clicked on {scroll;button}
 * @property {GUID} sessionId - users session id
 * @property {string} rankerParameters - ranker_parameters
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} rankerType - manual pricing/ data science model / scoring ect.
 * @property {number} numOfResults - the num of results displayed
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<exploreLoadPageParams>} LogObject<exploreLoadPageParams>
 */
export function exploreLoadPage(params) {
    return { evid: 15, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickToChooseAService' event (evid: 151)
 *
 * Event description: User clicks on "services" on the top menu or clicks on "choose a service" to open the services dropdown.
 *
 * @param {homePageClickToChooseAServiceParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} serviceName - connect domain / get website guidance ...
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / button
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickToChooseAServiceParams>} LogObject<homePageClickToChooseAServiceParams>
 */
export function homePageClickToChooseAService(params) {
    return { evid: 151, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnAServiceCategory' event (evid: 152)
 *
 * Event description: User clicks on a service category on the top menu dropdown / service category strip / service button dropdown
 *
 * @param {homePageClickOnAServiceCategoryParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} serviceCategory - category name: web design / small tasks ...
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / button / strip
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnAServiceCategoryParams>} LogObject<homePageClickOnAServiceCategoryParams>
 */
export function homePageClickOnAServiceCategory(params) {
    return { evid: 152, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnASpecificService' event (evid: 153)
 *
 * Event description: User clicks on a service on the service category strip
 *
 * @param {homePageClickOnASpecificServiceParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - service category number
 * @property {string} serviceCategory - category name: web design / small tasks
 * @property {number} innerType - service type number
 * @property {string} serviceName - migrate website / connect domain
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - service strip / explore
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnASpecificServiceParams>} LogObject<homePageClickOnASpecificServiceParams>
 */
export function homePageClickOnASpecificService(params) {
    return { evid: 153, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnSmallTasks' event (evid: 154)
 *
 * Event description: User clicks on small tasks on the top menu dropdown / small tasks strip / service button dropdown
 *
 * @param {homePageClickOnSmallTasksParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / button / strip
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnSmallTasksParams>} LogObject<homePageClickOnSmallTasksParams>
 */
export function homePageClickOnSmallTasks(params) {
    return { evid: 154, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnASmallTaskService' event (evid: 155)
 *
 * Event description: User clicks on a "Design your own website" on the web design strip
 *
 * @param {homePageClickOnASmallTaskServiceParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - strip / small tasks page
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnASmallTaskServiceParams>} LogObject<homePageClickOnASmallTaskServiceParams>
 */
export function homePageClickOnASmallTaskService(params) {
    return { evid: 155, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnBrowseAllExperts' event (evid: 156)
 *
 * Event description: User clicks on "Browse All Experts"
 *
 * @param {homePageClickOnBrowseAllExpertsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - button / how is works / small tasks ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnBrowseAllExpertsParams>} LogObject<homePageClickOnBrowseAllExpertsParams>
 */
export function homePageClickOnBrowseAllExperts(params) {
    return { evid: 156, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnFindMeAnExpert' event (evid: 157)
 *
 * Event description: User clicks on "Find Me an Expert"
 *
 * @param {homePageClickOnFindMeAnExpertParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - button / how is works / small tasks ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnFindMeAnExpertParams>} LogObject<homePageClickOnFindMeAnExpertParams>
 */
export function homePageClickOnFindMeAnExpert(params) {
    return { evid: 157, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnHowItWorks' event (evid: 158)
 *
 * Event description: User clicks on "How it Works"
 *
 * @param {homePageClickOnHowItWorksParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - button / how is works / small tasks ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnHowItWorksParams>} LogObject<homePageClickOnHowItWorksParams>
 */
export function homePageClickOnHowItWorks(params) {
    return { evid: 158, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefQuestionView' event (evid: 159)
 *
 * Event description: user views a question in the brief
 *
 * @param {briefQuestionViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - difm / seo / bm ...
 * @property {string} category - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} jsonData - {json data}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<briefQuestionViewParams>} LogObject<briefQuestionViewParams>
 */
export function briefQuestionView(params) {
    return { evid: 159, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userHpAdditionalProfilesLoaded' event (evid: 16)
 *
 * Event description: profiles page was loaded
 *
 * @param {userHpAdditionalProfilesLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} city - user_city
 * @property {GUID} visitorId - visitor_id
 * @property {string} filterValue - filter_value
 * @property {string} state - state
 * @property {string} filterType - filter_type
 * @property {string} sortBy - sort_by
 * @property {string} list_preset - {location of expert on page}
 * @property {string} text - {search term}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} country - country
 * @property {number} numberOfItems - count
 * @property {string} language - language
 * @property {string} sortType - sort_type
 * @property {string} origin - {}
 * @property {string} pageView - page_view
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userHpAdditionalProfilesLoadedParams>} LogObject<userHpAdditionalProfilesLoadedParams>
 */
export function userHpAdditionalProfilesLoaded(params) {
    return { evid: 16, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefCreateOnYourOwn' event (evid: 160)
 *
 * Event description: user click on "create on your own"
 *
 * @param {briefCreateOnYourOwnParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} origin - difm / other
 * @property {string} category - question name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<briefCreateOnYourOwnParams>} LogObject<briefCreateOnYourOwnParams>
 */
export function briefCreateOnYourOwn(params) {
    return { evid: 160, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefClickOnViewPortfolio' event (evid: 161)
 *
 * Event description: user click on "view portfolio"
 *
 * @param {briefClickOnViewPortfolioParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} isMatched - true if it's the agency that was matched / false
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - arena user guid
 * @return {LogObject<briefClickOnViewPortfolioParams>} LogObject<briefClickOnViewPortfolioParams>
 */
export function briefClickOnViewPortfolio(params) {
    return { evid: 161, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefClickOnGetInTouch' event (evid: 162)
 *
 * Event description: user click on "Get In Touch"
 *
 * @param {briefClickOnGetInTouchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - json with the brief answers
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - arena user guid
 * @return {LogObject<briefClickOnGetInTouchParams>} LogObject<briefClickOnGetInTouchParams>
 */
export function briefClickOnGetInTouch(params) {
    return { evid: 162, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'resultsPageClickOnBack' event (evid: 163)
 *
 * Event description: user click on "back" from the results page
 *
 * @param {resultsPageClickOnBackParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<resultsPageClickOnBackParams>} LogObject<resultsPageClickOnBackParams>
 */
export function resultsPageClickOnBack(params) {
    return { evid: 163, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefReviewProjectStatus' event (evid: 164)
 *
 * Event description: user click to review project status from the results page
 *
 * @param {briefReviewProjectStatusParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / other
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - the brief_id from the arena API
 * @return {LogObject<briefReviewProjectStatusParams>} LogObject<briefReviewProjectStatusParams>
 */
export function briefReviewProjectStatus(params) {
    return { evid: 164, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'brief404Error' event (evid: 166)
 *
 * Event description: user views a 404 error page in the brief
 *
 * @param {brief404ErrorParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / seo / bm ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<brief404ErrorParams>} LogObject<brief404ErrorParams>
 */
export function brief404Error(params) {
    return { evid: 166, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'brief404ErrorTryAgain' event (evid: 167)
 *
 * Event description: user clicks on "try again" in the 404 error page in the brief
 *
 * @param {brief404ErrorTryAgainParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} origin - difm / seo / bm ...
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<brief404ErrorTryAgainParams>} LogObject<brief404ErrorTryAgainParams>
 */
export function brief404ErrorTryAgain(params) {
    return { evid: 167, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'homePageClickOnExploreServices' event (evid: 168)
 *
 * Event description: User clicks on "Explore Services" on "browse all services"
 *
 * @param {homePageClickOnExploreServicesParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - top menu / home page strip
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<homePageClickOnExploreServicesParams>} LogObject<homePageClickOnExploreServicesParams>
 */
export function homePageClickOnExploreServices(params) {
    return { evid: 168, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceSeeFullReviewClick' event (evid: 169)
 *
 * Event description: Fires when clicks to read the full review from the project details page in the Marketplace Dashboard
 *
 * @param {marketplaceSeeFullReviewClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - job id
 * @property {number} typeid - Marketplace/internal
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} msid - review sites id
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceSeeFullReviewClickParams>} LogObject<marketplaceSeeFullReviewClickParams>
 */
export function marketplaceSeeFullReviewClick(params) {
    return { evid: 169, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceOpenReplyToReviewClick' event (evid: 170)
 *
 * Event description: Fires, when clicks to open, reply window  to review
 *
 * @param {marketplaceOpenReplyToReviewClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - job id
 * @property {number} typeid - Marketplace/internal
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceOpenReplyToReviewClickParams>} LogObject<marketplaceOpenReplyToReviewClickParams>
 */
export function marketplaceOpenReplyToReviewClick(params) {
    return { evid: 170, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplacePublishReplyToReview' event (evid: 171)
 *
 * Event description: Fires when partners click to publish a response to a review
 *
 * @param {marketplacePublishReplyToReviewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - job id
 * @property {string} text - response
 * @property {number} typeid - Marketplace/internal
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplacePublishReplyToReviewParams>} LogObject<marketplacePublishReplyToReviewParams>
 */
export function marketplacePublishReplyToReview(params) {
    return { evid: 171, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'joinMarketplaceLpClick' event (evid: 172)
 *
 * Event description: When clicking on CTA on join marketplace LP with click type for each CTA
 *
 * @param {joinMarketplaceLpClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} clickType - Which CTA
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<joinMarketplaceLpClickParams>} LogObject<joinMarketplaceLpClickParams>
 */
export function joinMarketplaceLpClick(params) {
    return { evid: 172, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewViewNewLeads' event (evid: 173)
 *
 * Event description: View New Leads in the Overview dashboard
 *
 * @param {overviewViewNewLeadsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewViewNewLeadsParams>} LogObject<overviewViewNewLeadsParams>
 */
export function overviewViewNewLeads(params) {
    return { evid: 173, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewLowCompletionRateWarningView' event (evid: 175)
 *
 * Event description: Overview - warning tooltip view (Low Completion Rate Warning).
 *
 * @param {overviewLowCompletionRateWarningViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} date_range - 7/30/60/90
 * @property {string} warning_type - warning_type
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewLowCompletionRateWarningViewParams>} LogObject<overviewLowCompletionRateWarningViewParams>
 */
export function overviewLowCompletionRateWarningView(params) {
    return { evid: 175, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewTableDateRangeSelection' event (evid: 176)
 *
 * Event description: Event fires when the user clicks change leads table date range
 *
 * @param {overviewTableDateRangeSelectionParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} date_range - 7/30/60/90
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewTableDateRangeSelectionParams>} LogObject<overviewTableDateRangeSelectionParams>
 */
export function overviewTableDateRangeSelection(params) {
    return { evid: 176, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewTableOrderBy' event (evid: 177)
 *
 * Event description: Event fires when the users clicks to reorder the leads table Overview dashboard
 *
 * @param {overviewTableOrderByParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} orderType - service/leads....
 * @property {string} order_method - DESC/ASC
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewTableOrderByParams>} LogObject<overviewTableOrderByParams>
 */
export function overviewTableOrderBy(params) {
    return { evid: 177, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewClickLowCompletionRateWarning' event (evid: 178)
 *
 * Event description: Event fires when a user clicks to remove service form view Low Completion Rate Warningin the Overview dashboard
 *
 * @param {overviewClickLowCompletionRateWarningParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} date_range - 7/30/60...
 * @property {string} warning_type - specific service/location
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewClickLowCompletionRateWarningParams>} LogObject<overviewClickLowCompletionRateWarningParams>
 */
export function overviewClickLowCompletionRateWarning(params) {
    return { evid: 178, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewLoaded' event (evid: 179)
 *
 * Event description: Overview dashboard loaded
 *
 * @param {overviewLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewLoadedParams>} LogObject<overviewLoadedParams>
 */
export function overviewLoaded(params) {
    return { evid: 179, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'quickProFindClick' event (evid: 18)
 *
 * Event description: Quick Pro Find was clicked (go to breif for 6 random pros)
 *
 * @param {quickProFindClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - {visitor_guid if uuid not signed in}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} srcPageName - src_page_name
 * @property {string} origin - {header/cta}
 * @property {boolean} isUserLoggedIn - is_user_logged_in
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<quickProFindClickParams>} LogObject<quickProFindClickParams>
 */
export function quickProFindClick(params) {
    return { evid: 18, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'overviewDisplayedCompletionRateWarning' event (evid: 180)
 *
 * Event description: Event fires when a user sees Low Completion Rate Warningin the Overview dashboard
 *
 * @param {overviewDisplayedCompletionRateWarningParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} warning_type - specific service/location
 * @property {string} view_type - view by Service/ location
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<overviewDisplayedCompletionRateWarningParams>} LogObject<overviewDisplayedCompletionRateWarningParams>
 */
export function overviewDisplayedCompletionRateWarning(params) {
    return { evid: 180, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'getHiredPageLoaded' event (evid: 181)
 *
 * Event description: User vised the Get Hired page in the Marketplace
 *
 * @param {getHiredPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<getHiredPageLoadedParams>} LogObject<getHiredPageLoadedParams>
 */
export function getHiredPageLoaded(params) {
    return { evid: 181, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pageAnswersInTheBrief' event (evid: 182)
 *
 * Event description: Fires when clicking next (or skip) and contains a string/JSON with all the questions and answers
 *
 * @param {pageAnswersInTheBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} previousScreenName - previous Screen Name
 * @property {string} wowVersion - wow_version for testing
 * @property {string} sessionId - {}
 * @property {string} answer - Screen Q&A
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} nextScreenName - next screen name
 * @return {LogObject<pageAnswersInTheBriefParams>} LogObject<pageAnswersInTheBriefParams>
 */
export function pageAnswersInTheBrief(params) {
    return { evid: 182, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'clicksOnScreenInTheBrief' event (evid: 183)
 *
 * Event description: Fires when clicking/selecting an option
 *
 * @param {clicksOnScreenInTheBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow version for testing
 * @property {string} sessionId - {}
 * @property {string} answer - Screen Q&A
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clicksOnScreenInTheBriefParams>} LogObject<clicksOnScreenInTheBriefParams>
 */
export function clicksOnScreenInTheBrief(params) {
    return { evid: 183, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'screenViewInTheBrief' event (evid: 184)
 *
 * Event description: Fires when a page is loaded on a screen
 *
 * @param {screenViewInTheBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {0-10}
 * @property {string} screenName - screen name
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} previousScreenName - previous Screen Name
 * @property {string} wowVersion - wow version for testing
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<screenViewInTheBriefParams>} LogObject<screenViewInTheBriefParams>
 */
export function screenViewInTheBrief(params) {
    return { evid: 184, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'leadsProjectsDashboardTableOrderBy' event (evid: 185)
 *
 * Event description: Event fires when the users clicks to reorder the leads table Leads/Projects views
 *
 * @param {leadsProjectsDashboardTableOrderByParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} order_type - Service/Date/Status..
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - Leads tab/Projects tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} order_method - DESC/ASC
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<leadsProjectsDashboardTableOrderByParams>} LogObject<leadsProjectsDashboardTableOrderByParams>
 */
export function leadsProjectsDashboardTableOrderBy(params) {
    return { evid: 185, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'leadsProjectsDashboardSearch' event (evid: 186)
 *
 * Event description: Event fires when the users clicks to search
 *
 * @param {leadsProjectsDashboardSearchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} search_term - search what
 * @property {string} origin - Leads tab/Projects tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<leadsProjectsDashboardSearchParams>} LogObject<leadsProjectsDashboardSearchParams>
 */
export function leadsProjectsDashboardSearch(params) {
    return { evid: 186, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'businessRulesToastLoaded' event (evid: 188)
 *
 * Event description: Triggers on the load of a toast related to biz rules
 *
 * @param {businessRulesToastLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} toast - toast that triggers
 * @return {LogObject<businessRulesToastLoadedParams>} LogObject<businessRulesToastLoadedParams>
 */
export function businessRulesToastLoaded(params) {
    return { evid: 188, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'businessRulesClickToast' event (evid: 189)
 *
 * Event description: Triggers on the click of a toast related to biz rules
 *
 * @param {businessRulesClickToastParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} clickType - click type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} toast - toast that triggers
 * @return {LogObject<businessRulesClickToastParams>} LogObject<businessRulesClickToastParams>
 */
export function businessRulesClickToast(params) {
    return { evid: 189, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userHpFiltering' event (evid: 19)
 *
 * Event description: expert pressed "my profile" (top right)
 *
 * @param {userHpFilteringParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} filterValue - (the country/lng)
 * @property {string} filterType - lng, country)
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sortType - ranking , num_of_projects
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userHpFilteringParams>} LogObject<userHpFilteringParams>
 */
export function userHpFiltering(params) {
    return { evid: 19, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceLightboxLoaded' event (evid: 190)
 *
 * Event description: triggers when load of a lightbox
 *
 * @param {marketplaceLightboxLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} lightboxType - lightbox type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceLightboxLoadedParams>} LogObject<marketplaceLightboxLoadedParams>
 */
export function marketplaceLightboxLoaded(params) {
    return { evid: 190, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceTabsGenericClick' event (evid: 192)
 *
 * Event description: Generic click in the marketplace Tabs
 *
 * @param {marketplaceTabsGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} tab_name - name of the tab
 * @property {string} clickType - type of click
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceTabsGenericClickParams>} LogObject<marketplaceTabsGenericClickParams>
 */
export function marketplaceTabsGenericClick(params) {
    return { evid: 192, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowGenericLoadPage' event (evid: 195)
 *
 * Event description: Generic loading page event
 *
 * @param {marketplacePostBriefFlowGenericLoadPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} otherPartners - partners
 * @property {number} partnerPosition - partner_position
 * @property {boolean} matched - true if partner matched with user
 * @property {number} reviewsScore - review score
 * @property {string} partnerId - partner Id
 * @property {string} origin - origin
 * @property {number} reviewQuantity - number of reviews
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} pageName - page name
 * @property {string} matchedPartners - matched partners
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFlowGenericLoadPageParams>} LogObject<marketplacePostBriefFlowGenericLoadPageParams>
 */
export function marketplacePostBriefFlowGenericLoadPage(params) {
    return { evid: 195, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowGenericClick' event (evid: 196)
 *
 * Event description: Clicks in the post brief flow
 *
 * @param {marketplacePostBriefFlowGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} tab - Tab
 * @property {number} partnerPosition - partner position
 * @property {boolean} matched - true if partner matched with user
 * @property {number} reviewsScore - score of reviews
 * @property {string} clickType - click_type
 * @property {string} partnerId - partner ID
 * @property {string} origin - origin
 * @property {number} reviewQuantity - number of reviews
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @property {string} product - product
 * @return {LogObject<marketplacePostBriefFlowGenericClickParams>} LogObject<marketplacePostBriefFlowGenericClickParams>
 */
export function marketplacePostBriefFlowGenericClick(params) {
    return { evid: 196, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowSendRequest' event (evid: 197)
 *
 * Event description: Fires when user sends request to partner
 *
 * @param {marketplacePostBriefFlowSendRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} partnerPosition - partner position
 * @property {number} reviewsScore - score of reviews
 * @property {string} partnerId - partner ID
 * @property {string} origin - origin
 * @property {number} reviewQuantity - number of reviews
 * @property {string} jobId - job id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFlowSendRequestParams>} LogObject<marketplacePostBriefFlowSendRequestParams>
 */
export function marketplacePostBriefFlowSendRequest(params) {
    return { evid: 197, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFunnelTooltipView' event (evid: 198)
 *
 * Event description: fires when user sees tooltip
 *
 * @param {marketplacePostBriefFunnelTooltipViewParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} tooltipName - tooltip name
 * @property {string} partnerId - partner id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFunnelTooltipViewParams>} LogObject<marketplacePostBriefFunnelTooltipViewParams>
 */
export function marketplacePostBriefFunnelTooltipView(params) {
    return { evid: 198, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'timeRangeChosen' event (evid: 199)
 *
 * Event description: Fires when user changes the time range
 *
 * @param {timeRangeChosenParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeRange - 7,30,60,90
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<timeRangeChosenParams>} LogObject<timeRangeChosenParams>
 */
export function timeRangeChosen(params) {
    return { evid: 199, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'missingParametersErrorEvent' event (evid: 20)
 *
 * Event description: fired when can't fire another event due to missing params
 *
 * @param {missingParametersErrorEventParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} filterType - lng, country)
 * @property {string} param - {missing param}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sortType - ranking , num_of_projects
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} event_id - {evid with missing param}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<missingParametersErrorEventParams>} LogObject<missingParametersErrorEventParams>
 */
export function missingParametersErrorEvent(params) {
    return { evid: 20, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userHpHoverOverProProfile' event (evid: 21)
 *
 * Event description: user hovered over pro profile
 *
 * @param {userHpHoverOverProProfileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} proCardLocationId - pro_card_location_id
 * @property {GUID} visitorId - {visitor_guid if user no signed in}
 * @property {string} filterValue - filter_value
 * @property {string} filterType - filter_type
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sortType - sort_type
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<userHpHoverOverProProfileParams>} LogObject<userHpHoverOverProProfileParams>
 */
export function userHpHoverOverProProfile(params) {
    return { evid: 21, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userProProfileProProfileClick' event (evid: 22)
 *
 * Event description: User clicks on an expert profile
 *
 * @param {userProProfileProProfileClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {number} proCardLocationId - not in use
 * @property {string} location - not in use
 * @property {GUID} visitorId - not in use
 * @property {string} filterValue - Json with all the filters
 * @property {number} innerType - not in use
 * @property {string} filterType - not in use
 * @property {string} term - not in use
 * @property {string} expertTotalScore - ETS
 * @property {number} reviewsScore - total reviews score
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} thumbnailId - not in use
 * @property {string} language - not in use
 * @property {string} sortType - not in use
 * @property {string} origin - {homepage / summary / search}
 * @property {number} budget - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<userProProfileProProfileClickParams>} LogObject<userProProfileProProfileClickParams>
 */
export function userProProfileProProfileClick(params) {
    return { evid: 22, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userHpBrowseProThumbnails' event (evid: 23)
 *
 * Event description: user browses in pro/project thumbnail
 *
 * @param {userHpBrowseProThumbnailsParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} proCardLocationId - pro_card_location_id
 * @property {GUID} visitorId - {}
 * @property {string} filterValue - filter_value
 * @property {string} filterType - filter_type
 * @property {GUID} projectId - project_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} thumbnailId - thumbnail_id
 * @property {string} sortType - sort_type
 * @property {string} origin - {homepage / summary}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<userHpBrowseProThumbnailsParams>} LogObject<userHpBrowseProThumbnailsParams>
 */
export function userHpBrowseProThumbnails(params) {
    return { evid: 23, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefFormEditingInfo' event (evid: 24)
 *
 * Event description: filter field was clicked (either lang or location); In mobile this is triggered by clicking the "location" or "language"
 *
 * @param {briefFormEditingInfoParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} session_id - depreciated
 * @property {boolean} isMandatory - depreciated
 * @property {number} briefPageNum - depreciated
 * @property {string} field_type - depreciated
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} fieldLength - depreciated
 * @property {string} fieldName - {Languages ; location}
 * @property {boolean} isAboveFold - depreciated
 * @property {boolean} isMultiplePros - depreciated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action - depreciated
 * @property {GUID} proGuid - depreciated
 * @return {LogObject<briefFormEditingInfoParams>} LogObject<briefFormEditingInfoParams>
 */
export function briefFormEditingInfo(params) {
    return { evid: 24, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefFormNavigationClick' event (evid: 25)
 *
 * Event description: client click on "See more experts" when reading the brief he sent
 *
 * @param {briefFormNavigationClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - ow long the user was in the page time_in_page (mlsec)
 * @property {GUID} jobRequestId - {}
 * @property {string} typeOfService - new site, existing site, logo
 * @property {string} navButtonLocation - depreciated
 * @property {boolean} isError - depreciated
 * @property {number} destBriefPage - depreciated
 * @property {string} navDirection - depreciated
 * @property {string} errorDesc - depreciated
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} filledFields - depreciated
 * @property {number} srcBriefPage - depreciated
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {boolean} isMultiplePros -  (0,1) - is it for a specific pro or for random multiple pros
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<briefFormNavigationClickParams>} LogObject<briefFormNavigationClickParams>
 */
export function briefFormNavigationClick(params) {
    return { evid: 25, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'leadsProjectDetailGenericClick' event (evid: 265)
 *
 * Event description: Fires on any click on the leads/Project detail page
 *
 * @param {leadsProjectDetailGenericClickParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - Job's ID
 * @property {string} jobStatus - job_status
 * @property {string} clickType - button pressed by user
 * @property {string} origin - origin: leads/project tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<leadsProjectDetailGenericClickParams>} LogObject<leadsProjectDetailGenericClickParams>
 */
export function leadsProjectDetailGenericClick(params) {
    return { evid: 265, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefFormSubmitWasClicked' event (evid: 27)
 *
 * Event description: client scrolls down when reading his submitted brief. "see more experts" button is shown
 *
 * @param {briefFormSubmitWasClickedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - ow long the user was in the page time_in_page (mlsec)
 * @property {GUID} jobRequestId - {}
 * @property {string} typeOfService - new site, existing site, logo
 * @property {boolean} isError - depreciated
 * @property {string} errorDesc - depreciated
 * @property {number} typeid - {}
 * @property {string} filledFields - depreciated
 * @property {GUID} sessionId - grouping all events of the same brief (prior to brief id assignment)
 * @property {boolean} isMultiplePros -  (0,1) - is it for a specific pro or for random multiple pros
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - only for specific pro, else null
 * @return {LogObject<briefFormSubmitWasClickedParams>} LogObject<briefFormSubmitWasClickedParams>
 */
export function briefFormSubmitWasClicked(params) {
    return { evid: 27, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'profilePageChangeTab' event (evid: 28)
 *
 * Event description: users clicks on a tab in the nav bar of an expert's profile page
 *
 * @param {profilePageChangeTabParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} visitorId - not in use
 * @property {GUID} visitorid - not in use
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origTabName - orig_tab_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} newTabName - new_tab_name
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<profilePageChangeTabParams>} LogObject<profilePageChangeTabParams>
 */
export function profilePageChangeTab(params) {
    return { evid: 28, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'seeCompletionRateInCategory' event (evid: 285)
 *
 * Event description: See Completion Rate In Category.
 *
 * @param {seeCompletionRateInCategoryParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} category - marketplace category
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<seeCompletionRateInCategoryParams>} LogObject<seeCompletionRateInCategoryParams>
 */
export function seeCompletionRateInCategory(params) {
    return { evid: 285, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplacePostBriefFlowChatLoaded' event (evid: 286)
 *
 * Event description: Clicks in the post brief flow
 *
 * @param {marketplacePostBriefFlowChatLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} partnerId - partner ID
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @return {LogObject<marketplacePostBriefFlowChatLoadedParams>} LogObject<marketplacePostBriefFlowChatLoadedParams>
 */
export function marketplacePostBriefFlowChatLoaded(params) {
    return { evid: 286, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'clickOnExpertProject' event (evid: 29)
 *
 * Event description: user clicks on an expert project from the profile or the explore page
 *
 * @param {clickOnExpertProjectParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} visitorId - not in use
 * @property {string} url - the url of the site clicked
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - explore page / expert profile
 * @property {number} siteLocationId - the location of the site in the profile
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} siteGuid - the msid of the site clicked
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<clickOnExpertProjectParams>} LogObject<clickOnExpertProjectParams>
 */
export function clickOnExpertProject(params) {
    return { evid: 29, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'profilePageClickOnExpertLinkedAccount' event (evid: 30)
 *
 * Event description: User clicks on expert linked account (portfolio erbsite/fb/Twitter/linkedin...) in the profile side bar
 *
 * @param {profilePageClickOnExpertLinkedAccountParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} communicationOption - facebook/linkedin/website
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} visitorid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - experts guid
 * @return {LogObject<profilePageClickOnExpertLinkedAccountParams>} LogObject<profilePageClickOnExpertLinkedAccountParams>
 */
export function profilePageClickOnExpertLinkedAccount(params) {
    return { evid: 30, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userProProfileClickedOnContactMe' event (evid: 31)
 *
 * Event description: User clicks on the experts CTA (and opens a direct brief) from the expert profile page or from the explore
 *
 * @param {userProProfileClickedOnContactMeParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - not in use
 * @property {string} location - not in use
 * @property {GUID} visitorId - not in use
 * @property {string} filterValue - json with the filters
 * @property {number} innerType - not in use
 * @property {string} expertTotalScore - ETS
 * @property {number} reviewsScore - total reviews score
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} language - not in use
 * @property {string} origin - explore page / expert profile
 * @property {number} budget - not in use
 * @property {boolean} isUserLoggedIn - not in use
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} originLocation - project details / services & rates ...
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - provider_guid
 * @return {LogObject<userProProfileClickedOnContactMeParams>} LogObject<userProProfileClickedOnContactMeParams>
 */
export function userProProfileClickedOnContactMe(params) {
    return { evid: 31, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceBriefClickPhoneFeature' event (evid: 310)
 *
 * Event description: Fires on clicks in the phone feature
 *
 * @param {marketplaceBriefClickPhoneFeatureParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} phoneCountryCode - country code
 * @property {string} clickType - click_type
 * @property {string} origin - {support;SEO Wizard}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} serviceId - {1;2; e.g. small fix; new website}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<marketplaceBriefClickPhoneFeatureParams>} LogObject<marketplaceBriefClickPhoneFeatureParams>
 */
export function marketplaceBriefClickPhoneFeature(params) {
    return { evid: 310, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefPageViewLastStep' event (evid: 318)
 *
 * Event description: Fires when a user enters the last step of the brief (contact info)
 *
 * @param {briefPageViewLastStepParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} briefType - {friendlier V1, Unified, ect}
 * @property {string} origin - {SEO, Logo ect.}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} previousStep - name of the previous step
 * @return {LogObject<briefPageViewLastStepParams>} LogObject<briefPageViewLastStepParams>
 */
export function briefPageViewLastStep(params) {
    return { evid: 318, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'becomeAProPageLoaded' event (evid: 32)
 *
 * Event description: Pro Intro page was loaded
 *
 * @param {becomeAProPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - depreciated. uuid is implicit
 * @return {LogObject<becomeAProPageLoadedParams>} LogObject<becomeAProPageLoadedParams>
 */
export function becomeAProPageLoaded(params) {
    return { evid: 32, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'marketplaceBriefGeneralAction' event (evid: 322)
 *
 * Event description: fires every time a user makes an action (click/keyboard fill) in MP brief
 *
 * @param {marketplaceBriefGeneralActionParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} step_name - name of step
 * @property {number} step_id - step id
 * @property {string} entry - entry point to brief
 * @property {string} data - data extracted from action
 * @property {string} briefType - Friendlier V1 / Friendlier V2 / Unified
 * @property {string} origin - {existing brief}
 * @property {string} sessionId - {}
 * @property {boolean} added_budget - True if the user added budget, false if the user chose that he is not sure what's his budget id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action_type - action_type
 * @return {LogObject<marketplaceBriefGeneralActionParams>} LogObject<marketplaceBriefGeneralActionParams>
 */
export function marketplaceBriefGeneralAction(params) {
    return { evid: 322, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressAddPremiumSite' event (evid: 33)
 *
 * Event description: add premium
 *
 * @param {pressAddPremiumSiteParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} buttonType - add new / add premium
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - depreciated
 * @return {LogObject<pressAddPremiumSiteParams>} LogObject<pressAddPremiumSiteParams>
 */
export function pressAddPremiumSite(params) {
    return { evid: 33, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressNextOnSubmitAPro' event (evid: 34)
 *
 * Event description: pressing next in pro brief
 *
 * @param {pressNextOnSubmitAProParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {since previous step}
 * @property {number} step - {step_number}
 * @property {string} buttonType - button_type
 * @property {string} data - {json data}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - deprecated
 * @property {boolean} validation - {}
 * @return {LogObject<pressNextOnSubmitAProParams>} LogObject<pressNextOnSubmitAProParams>
 */
export function pressNextOnSubmitAPro(params) {
    return { evid: 34, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressAddSiteAfterAddingUrl' event (evid: 35)
 *
 * Event description: adding and validating the url as wix premium
 *
 * @param {pressAddSiteAfterAddingUrlParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} proStatus - pro_status
 * @property {string} source - source
 * @property {string} url - url
 * @property {boolean} isFirstComplete - is_first_complete
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - origin
 * @property {GUID} sessionId - session_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @property {boolean} validation - {true/false}
 * @return {LogObject<pressAddSiteAfterAddingUrlParams>} LogObject<pressAddSiteAfterAddingUrlParams>
 */
export function pressAddSiteAfterAddingUrl(params) {
    return { evid: 35, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proSubmitFormAsCandidate' event (evid: 38)
 *
 * Event description: pro form submitted
 *
 * @param {proSubmitFormAsCandidateParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {MS since brief loaded}
 * @property {number} briefPageNum - deprecated
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} fieldLength - deprecated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} fieldType - deprecated
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action - deprecated
 * @property {boolean} validation - {}
 * @return {LogObject<proSubmitFormAsCandidateParams>} LogObject<proSubmitFormAsCandidateParams>
 */
export function proSubmitFormAsCandidate(params) {
    return { evid: 38, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proFormSubmitedSuccessfully' event (evid: 42)
 *
 * Event description: Request was submitted: thank you page
 *
 * @param {proFormSubmitedSuccessfullyParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} processTime - depreciated
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<proFormSubmitedSuccessfullyParams>} LogObject<proFormSubmitedSuccessfullyParams>
 */
export function proFormSubmitedSuccessfully(params) {
    return { evid: 42, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proProfileEditProfileChangePublishClicked' event (evid: 43)
 *
 * Event description: edit profile page loaded (after approved before live)
 *
 * @param {proProfileEditProfileChangePublishClickedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} profileTab - deprecated
 * @property {string} filledFields - deprecated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<proProfileEditProfileChangePublishClickedParams>} LogObject<proProfileEditProfileChangePublishClickedParams>
 */
export function proProfileEditProfileChangePublishClicked(params) {
    return { evid: 43, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proProfileEditProfileChangePublishRequest' event (evid: 44)
 *
 * Event description: expert press different tabs while updating profile
 *
 * @param {proProfileEditProfileChangePublishRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} isValid - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origTabName - {}
 * @property {string} profileTab - profile_tab
 * @property {string} filledFields - f_name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} newTabName - {}
 * @return {LogObject<proProfileEditProfileChangePublishRequestParams>} LogObject<proProfileEditProfileChangePublishRequestParams>
 */
export function proProfileEditProfileChangePublishRequest(params) {
    return { evid: 44, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proProfileEditProfileChangePublishDone' event (evid: 45)
 *
 * Event description: edit / hide / show / delete site in pro profile
 *
 * @param {proProfileEditProfileChangePublishDoneParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {Url} url - {site_url}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} profileTab - profile_tab
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} processTime - process_time
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {string} action - {hide/show}
 * @return {LogObject<proProfileEditProfileChangePublishDoneParams>} LogObject<proProfileEditProfileChangePublishDoneParams>
 */
export function proProfileEditProfileChangePublishDone(params) {
    return { evid: 45, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proProfileEditSaveButtonClicked' event (evid: 46)
 *
 * Event description: press save profile
 *
 * @param {proProfileEditSaveButtonClickedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {milliseconds between page load and submit}
 * @property {string} buttonType - {top/bottom}
 * @property {string} data - {json_string}
 * @property {boolean} isFirst - {first time the user edits}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} isFirstTimeLive - is_first_time_live
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} validation - {}
 * @return {LogObject<proProfileEditSaveButtonClickedParams>} LogObject<proProfileEditSaveButtonClickedParams>
 */
export function proProfileEditSaveButtonClicked(params) {
    return { evid: 46, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proProfileUserBrief' event (evid: 47)
 *
 * Event description: reviewed a user brief
 *
 * @param {proProfileUserBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {guid from server}
 * @property {string} typeOfService - type_of_service
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {email / dashboard}
 * @property {boolean} isMultiplePros - deprecated
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief_id
 * @property {GUID} proGuid - deprecated
 * @return {LogObject<proProfileUserBriefParams>} LogObject<proProfileUserBriefParams>
 */
export function proProfileUserBrief(params) {
    return { evid: 47, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userHomepageLoaded' event (evid: 49)
 *
 * Event description: user homepage loaded; if user logged in uuid provided.
 *
 * @param {userHomepageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} referral_name - {}
 * @property {GUID} visitorId - depreciated
 * @property {string} list_preset - {location of expert on page}
 * @property {number} height - Initial height of client window
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} language - arena_lang
 * @property {string} origin - {}
 * @property {number} loadTime - {time in MS from start to load until finish load}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - Initial width of client window
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userHomepageLoadedParams>} LogObject<userHomepageLoadedParams>
 */
export function userHomepageLoaded(params) {
    return { evid: 49, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefPageLoaded' event (evid: 50)
 *
 * Event description: brief loaded
 *
 * @param {briefPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - data
 * @property {number} height - height
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {login}
 * @property {string} sessionId - session_id
 * @property {GUID} visitorid - {visitor guid if the user not logged in}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - width
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @return {LogObject<briefPageLoadedParams>} LogObject<briefPageLoadedParams>
 */
export function briefPageLoaded(params) {
    return { evid: 50, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userExitBrief' event (evid: 51)
 *
 * Event description: brief window not in focus (user moved to another tab/ window)
 *
 * @param {userExitBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {milliseconds between brief loaded and exit}
 * @property {string} data - {json that contains the brief}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<userExitBriefParams>} LogObject<userExitBriefParams>
 */
export function userExitBrief(params) {
    return { evid: 51, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'submitBrief' event (evid: 52)
 *
 * Event description: user submits brief
 *
 * @param {submitBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - time_in_page
 * @property {boolean} sameBriefExperts - 1:same brief; 0 - not same brief
 * @property {string} data - data
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - session_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @property {boolean} validation - {true-validated; false-validation failed}
 * @return {LogObject<submitBriefParams>} LogObject<submitBriefParams>
 */
export function submitBrief(params) {
    return { evid: 52, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressNext' event (evid: 53)
 *
 * Event description: user press next in brief
 *
 * @param {pressNextParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - time_in_page
 * @property {number} step - step_id
 * @property {string} data - data
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - origin
 * @property {string} sessionId - session_id
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - pro_guid
 * @property {boolean} validation - {true-validated; false-validation failed}
 * @return {LogObject<pressNextParams>} LogObject<pressNextParams>
 */
export function pressNext(params) {
    return { evid: 53, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressBack' event (evid: 54)
 *
 * Event description: user press back in brief
 *
 * @param {pressBackParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {milliseconds between step loaded and press back}
 * @property {number} step - {page number where next pressed}
 * @property {string} screenName - screen name
 * @property {string} data - {json that contains the brief}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow_version for testing
 * @property {string} origin - {button ; step_name}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressBackParams>} LogObject<pressBackParams>
 */
export function pressBack(params) {
    return { evid: 54, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefAcceptedByServer' event (evid: 55)
 *
 * Event description: brief accepted by server
 *
 * @param {briefAcceptedByServerParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {number} timeInterval - {milliseconds between brief submit and brief accepted -this event}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - {}
 * @return {LogObject<briefAcceptedByServerParams>} LogObject<briefAcceptedByServerParams>
 */
export function briefAcceptedByServer(params) {
    return { evid: 55, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'askToSendBriefToProsRequestToServer' event (evid: 56)
 *
 * Event description: brief accepted by server and asked to send to pros
 *
 * @param {askToSendBriefToProsRequestToServerParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {session ID for this brief}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - {}
 * @return {LogObject<askToSendBriefToProsRequestToServerParams>} LogObject<askToSendBriefToProsRequestToServerParams>
 */
export function askToSendBriefToProsRequestToServer(params) {
    return { evid: 56, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'thankYouForSubmittingBrief' event (evid: 57)
 *
 * Event description: thank you page after brief was submitted successfully
 *
 * @param {thankYouForSubmittingBriefParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - {}
 * @property {GUID} proGuid - {}
 * @return {LogObject<thankYouForSubmittingBriefParams>} LogObject<thankYouForSubmittingBriefParams>
 */
export function thankYouForSubmittingBrief(params) {
    return { evid: 57, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressBackOnSubmitAPro' event (evid: 58)
 *
 * Event description: pressing back in pro brief
 *
 * @param {pressBackOnSubmitAProParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} timeInPage - {since previous step}
 * @property {number} step - {step_number}
 * @property {string} buttonType - top , bottom
 * @property {string} data - {json data}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} validation - {}
 * @return {LogObject<pressBackOnSubmitAProParams>} LogObject<pressBackOnSubmitAProParams>
 */
export function pressBackOnSubmitAPro(params) {
    return { evid: 58, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'becomeAProPendingRequest' event (evid: 59)
 *
 * Event description: pro tries to submit again - got pending request page
 *
 * @param {becomeAProPendingRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<becomeAProPendingRequestParams>} LogObject<becomeAProPendingRequestParams>
 */
export function becomeAProPendingRequest(params) {
    return { evid: 59, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'proGoLive' event (evid: 60)
 *
 * Event description: pro press go live to profile
 *
 * @param {proGoLiveParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<proGoLiveParams>} LogObject<proGoLiveParams>
 */
export function proGoLive(params) {
    return { evid: 60, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'userAlreadySentGroupRequest' event (evid: 61)
 *
 * Event description: User submit request and received a page: "you have already sent a group request"
 *
 * @param {userAlreadySentGroupRequestParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<userAlreadySentGroupRequestParams>} LogObject<userAlreadySentGroupRequestParams>
 */
export function userAlreadySentGroupRequest(params) {
    return { evid: 61, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertTryToContactAnotherExpert' event (evid: 62)
 *
 * Event description: expert receives explanation message that he can't contact another expert but can contact himself
 *
 * @param {expertTryToContactAnotherExpertParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertTryToContactAnotherExpertParams>} LogObject<expertTryToContactAnotherExpertParams>
 */
export function expertTryToContactAnotherExpert(params) {
    return { evid: 62, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertTryContactOtherExpertsInFindMeAPro' event (evid: 63)
 *
 * Event description: expert receives explanation message that he can't contact another experts in the "find me a pro" flow
 *
 * @param {expertTryContactOtherExpertsInFindMeAProParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertTryContactOtherExpertsInFindMeAProParams>} LogObject<expertTryContactOtherExpertsInFindMeAProParams>
 */
export function expertTryContactOtherExpertsInFindMeAPro(params) {
    return { evid: 63, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'removeSiteFromApplication' event (evid: 64)
 *
 * Event description: pressing remove a site from application (become an expert)
 *
 * @param {removeSiteFromApplicationParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} url - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<removeSiteFromApplicationParams>} LogObject<removeSiteFromApplicationParams>
 */
export function removeSiteFromApplication(params) {
    return { evid: 64, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'approveRemoveSiteFromApplication' event (evid: 65)
 *
 * Event description: pressing yes on the are you sure screen before removing a site from application (become an expert)
 *
 * @param {approveRemoveSiteFromApplicationParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} url - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<approveRemoveSiteFromApplicationParams>} LogObject<approveRemoveSiteFromApplicationParams>
 */
export function approveRemoveSiteFromApplication(params) {
    return { evid: 65, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'internalInfoPageLoaded' event (evid: 66)
 *
 * Event description: internal "info" page loaded
 *
 * @param {internalInfoPageLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {become_an_expert;T&C;how_it_works }
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {email;direct;homepage}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<internalInfoPageLoadedParams>} LogObject<internalInfoPageLoadedParams>
 */
export function internalInfoPageLoaded(params) {
    return { evid: 66, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'clickOnFiltersMobile' event (evid: 68)
 *
 * Event description: filter field was clicked in mobile only (since this stage doesn't exist in desktop)
 *
 * @param {clickOnFiltersMobileParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clickOnFiltersMobileParams>} LogObject<clickOnFiltersMobileParams>
 */
export function clickOnFiltersMobile(params) {
    return { evid: 68, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'newOrExistingBriefNotification' event (evid: 69)
 *
 * Event description: new-or-existing-brief notification
 *
 * @param {newOrExistingBriefNotificationParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {page name}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<newOrExistingBriefNotificationParams>} LogObject<newOrExistingBriefNotificationParams>
 */
export function newOrExistingBriefNotification(params) {
    return { evid: 69, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'loginIntroPage' event (evid: 71)
 *
 * Event description: login intro page load
 *
 * @param {loginIntroPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {string} type - {direct/indirect}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<loginIntroPageParams>} LogObject<loginIntroPageParams>
 */
export function loginIntroPage(params) {
    return { evid: 71, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressProceedToLoginOnIntroPage' event (evid: 72)
 *
 * Event description: press proceed to login or signup on intro page
 *
 * @param {pressProceedToLoginOnIntroPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} name - {login/signup}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressProceedToLoginOnIntroPageParams>} LogObject<pressProceedToLoginOnIntroPageParams>
 */
export function pressProceedToLoginOnIntroPage(params) {
    return { evid: 72, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'newBriefLoaded73' event (evid: 73)
 *
 * Event description: Brief is loaded
 *
 * @param {newBriefLoaded73Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} serviceType - {1;2; e.g. small fix; new website}
 * @property {number} innerType - {1;2}
 * @property {string} entry - e.g, generalMenu, support_banner
 * @property {string} data - {}
 * @property {number} height - {}
 * @property {string} briefType - {WoW/three_steps/six_steps/dedicated}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow_version for Testing
 * @property {string} origin - {login}
 * @property {string} sessionId - {}
 * @property {string} productName - the product the brief was opened in ( auto-match/ results page / explore/ partner profile)
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {number} width - {}
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} inMarketplace - is partner in the marketplace?
 * @return {LogObject<newBriefLoaded73Params>} LogObject<newBriefLoaded73Params>
 */
export function newBriefLoaded73(params) {
    return { evid: 73, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'submitBrief74' event (evid: 74)
 *
 * Event description: User press on submit in the new brief
 *
 * @param {submitBrief74Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} phoneFilled - if phone was filled
 * @property {number} serviceType - embedded_service_id
 * @property {string} phoneCountryCode - US, GB, etc
 * @property {string} matching_algorithm_engine - random/ low demand/ high demand
 * @property {number} innerType - innerType
 * @property {string} budget_number - number the user added for the budget
 * @property {string} state - state (sub-country)
 * @property {string} entry - entry point to brief
 * @property {string} data - {}
 * @property {string} briefType - brief_type
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} job_id - list of job ids for the brief
 * @property {string} wowVersion - wow_version for testing
 * @property {string} origin - {existing brief}
 * @property {string} budget_currency - Currency the user chose for the budget
 * @property {string} sessionId - {}
 * @property {boolean} added_budget - True if the user added a budget, false if the user marked he isn't sure what's his budget is
 * @property {string} productName - the product the brief came from - auto-match/results page/explore/partner profile
 * @property {boolean} is_exclusive - true if exclusive brief
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief id
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {}
 * @property {boolean} inMarketplace - is partner is in marketplace
 * @return {LogObject<submitBrief74Params>} LogObject<submitBrief74Params>
 */
export function submitBrief74(params) {
    return { evid: 74, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'briefSuccessPageRequestCreated' event (evid: 75)
 *
 * Event description: Brief Success Page (for contact details): your request was created page
 *
 * @param {briefSuccessPageRequestCreatedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} wowVersion - wow version for testing
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} briefId - brief submitted id
 * @return {LogObject<briefSuccessPageRequestCreatedParams>} LogObject<briefSuccessPageRequestCreatedParams>
 */
export function briefSuccessPageRequestCreated(params) {
    return { evid: 75, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressSendRequestNow' event (evid: 76)
 *
 * Event description: press send request now on 'project created' page
 *
 * @param {pressSendRequestNowParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressSendRequestNowParams>} LogObject<pressSendRequestNowParams>
 */
export function pressSendRequestNow(params) {
    return { evid: 76, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressAddDetailsOnProjectCreatedPage' event (evid: 77)
 *
 * Event description: press 'add details' on 'project created' page
 *
 * @param {pressAddDetailsOnProjectCreatedPageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<pressAddDetailsOnProjectCreatedPageParams>} LogObject<pressAddDetailsOnProjectCreatedPageParams>
 */
export function pressAddDetailsOnProjectCreatedPage(params) {
    return { evid: 77, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'step1InBriefLoaded' event (evid: 78)
 *
 * Event description: you already sent a group request (new brief)
 *
 * @param {step1InBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<step1InBriefLoadedParams>} LogObject<step1InBriefLoadedParams>
 */
export function step1InBriefLoaded(params) {
    return { evid: 78, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressSkipInStep1' event (evid: 79)
 *
 * Event description: press skip in step 1
 *
 * @param {pressSkipInStep1Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressSkipInStep1Params>} LogObject<pressSkipInStep1Params>
 */
export function pressSkipInStep1(params) {
    return { evid: 79, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressAddFinalDetailsInStep1' event (evid: 80)
 *
 * Event description: press add final details in step 1
 *
 * @param {pressAddFinalDetailsInStep1Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressAddFinalDetailsInStep1Params>} LogObject<pressAddFinalDetailsInStep1Params>
 */
export function pressAddFinalDetailsInStep1(params) {
    return { evid: 80, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'step2InBriefLoaded' event (evid: 81)
 *
 * Event description: step 2 in brief loaded
 *
 * @param {step2InBriefLoadedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<step2InBriefLoadedParams>} LogObject<step2InBriefLoadedParams>
 */
export function step2InBriefLoaded(params) {
    return { evid: 81, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressSkipInStep2' event (evid: 82)
 *
 * Event description: press skip in step 2
 *
 * @param {pressSkipInStep2Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressSkipInStep2Params>} LogObject<pressSkipInStep2Params>
 */
export function pressSkipInStep2(params) {
    return { evid: 82, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'pressSaveInStep2' event (evid: 83)
 *
 * Event description: press save in step 2
 *
 * @param {pressSaveInStep2Params} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @return {LogObject<pressSaveInStep2Params>} LogObject<pressSaveInStep2Params>
 */
export function pressSaveInStep2(params) {
    return { evid: 83, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'submittedDoneAllDonePage' event (evid: 85)
 *
 * Event description: submitted done (all done) page
 *
 * @param {submittedDoneAllDonePageParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} step - {step_id that was submitted 1 or 2}
 * @property {string} data - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {GUID} proGuid - {}
 * @property {boolean} validation - {true-validated; false-validation failed}
 * @return {LogObject<submittedDoneAllDonePageParams>} LogObject<submittedDoneAllDonePageParams>
 */
export function submittedDoneAllDonePage(params) {
    return { evid: 85, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'clickOnMagnifyingGlassSearch' event (evid: 86)
 *
 * Event description: click on magnifying glass (search)
 *
 * @param {clickOnMagnifyingGlassSearchParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<clickOnMagnifyingGlassSearchParams>} LogObject<clickOnMagnifyingGlassSearchParams>
 */
export function clickOnMagnifyingGlassSearch(params) {
    return { evid: 86, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'submitSearchTerm' event (evid: 87)
 *
 * Event description: Submit search term
 *
 * @param {submitSearchTermParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {string} text - {search term}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} country - {country if filter was used}
 * @property {string} language - {lng if filter was used}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<submitSearchTermParams>} LogObject<submitSearchTermParams>
 */
export function submitSearchTerm(params) {
    return { evid: 87, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'searchResultsShown' event (evid: 88)
 *
 * Event description: search results shown
 *
 * @param {searchResultsShownParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {number} itemsCount - {number of results; no results =0}
 * @property {string} data - {array of providers guid first page}
 * @property {string} text - {search term}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} country - {country if filter was used}
 * @property {string} language - {lng if filter was used}
 * @property {string} sessionId - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<searchResultsShownParams>} LogObject<searchResultsShownParams>
 */
export function searchResultsShown(params) {
    return { evid: 88, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertClickGetStarted' event (evid: 89)
 *
 * Event description: click get started on banner leading to the project page
 *
 * @param {expertClickGetStartedParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {guid}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {email / dashboard}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertClickGetStartedParams>} LogObject<expertClickGetStartedParams>
 */
export function expertClickGetStarted(params) {
    return { evid: 89, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertNotAvailableToggle' event (evid: 90)
 *
 * Event description: expert changing the toggle
 *
 * @param {expertNotAvailableToggleParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {boolean} availability_modified - {true=available; false=not avaliable}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {toggle / top bar notification}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertNotAvailableToggleParams>} LogObject<expertNotAvailableToggleParams>
 */
export function expertNotAvailableToggle(params) {
    return { evid: 90, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'replyInDashboard' event (evid: 91)
 *
 * Event description: press "Yes, reopen" for reopening the canceled brief
 *
 * @param {replyInDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {string} button_name - {button/link}
 * @property {number} typeid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<replyInDashboardParams>} LogObject<replyInDashboardParams>
 */
export function replyInDashboard(params) {
    return { evid: 91, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'callClientInDashboard' event (evid: 92)
 *
 * Event description: Expert presses "call" in dashboard
 *
 * @param {callClientInDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {string} button_name - {button/link}
 * @property {number} typeid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<callClientInDashboardParams>} LogObject<callClientInDashboardParams>
 */
export function callClientInDashboard(params) {
    return { evid: 92, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertRejectedProject' event (evid: 93)
 *
 * Event description: expert dashboard change tab: requests and submitted websites
 *
 * @param {expertRejectedProjectParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {}
 * @property {string} tabName - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertRejectedProjectParams>} LogObject<expertRejectedProjectParams>
 */
export function expertRejectedProject(params) {
    return { evid: 93, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'expertSubmitRejectStatus' event (evid: 94)
 *
 * Event description: Expert presses "notify wix arena" in dashboard that he's not working on the project
 *
 * @param {expertSubmitRejectStatusParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<expertSubmitRejectStatusParams>} LogObject<expertSubmitRejectStatusParams>
 */
export function expertSubmitRejectStatus(params) {
    return { evid: 94, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'errorExpertTriesToOpenABriefThatDoesnTBelongToHim' event (evid: 95)
 *
 * Event description: error expert tries to open a brief that doesn't belong to him
 *
 * @param {errorExpertTriesToOpenABriefThatDoesnTBelongToHimParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - number of the brief's form
 * @property {number} typeid - {}
 * @property {string} errorName - error name
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<errorExpertTriesToOpenABriefThatDoesnTBelongToHimParams>} LogObject<errorExpertTriesToOpenABriefThatDoesnTBelongToHimParams>
 */
export function errorExpertTriesToOpenABriefThatDoesnTBelongToHim(params) {
    return { evid: 95, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'tellMeMoreInExpertDashboard' event (evid: 96)
 *
 * Event description: press 'tell me more' in expert dashboard
 *
 * @param {tellMeMoreInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<tellMeMoreInExpertDashboardParams>} LogObject<tellMeMoreInExpertDashboardParams>
 */
export function tellMeMoreInExpertDashboard(params) {
    return { evid: 96, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'copyAutomatedEmailInExpertDashboard' event (evid: 97)
 *
 * Event description: press 'copy this automated email' in expert dashboard
 *
 * @param {copyAutomatedEmailInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<copyAutomatedEmailInExpertDashboardParams>} LogObject<copyAutomatedEmailInExpertDashboardParams>
 */
export function copyAutomatedEmailInExpertDashboard(params) {
    return { evid: 97, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'copyToClipboardAutomatedEmailInExpertDashboard' event (evid: 98)
 *
 * Event description: press 'copy to clipboard' in expert dashboard
 *
 * @param {copyToClipboardAutomatedEmailInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<copyToClipboardAutomatedEmailInExpertDashboardParams>} LogObject<copyToClipboardAutomatedEmailInExpertDashboardParams>
 */
export function copyToClipboardAutomatedEmailInExpertDashboard(params) {
    return { evid: 98, src: 80, endpoint: 'marketplace', params: params };
}
/**
 * A function to create a log object for the 'notInterestedInProjectInExpertDashboard' event (evid: 99)
 *
 * Event description: press 'not interested in project' in expert dashboard
 *
 * @param {notInterestedInProjectInExpertDashboardParams} params - The parameters for this event
 * @property {string} __cookies_prefix___wixUIDX - user_id_container
 * @property {GUID} uuid - uuid
 * @property {GUID} __cookies_prefix__uuid - uuid
 * @property {GUID} _uuid - uuid
 * @property {GUID} owner_id - uuid
 * @property {GUID} edix_owner_id - edix_owner_id
 * @property {GUID} target_account_id - target_account_id
 * @property {GUID} __cookies_prefix__target_account_id - target_account_id
 * @property {GUID} ownerId - uuid
 * @property {GUID} _target_id_to_uuid - uuid
 * @property {GUID} _target_account_id - target_account_id
 * @property {GUID} jobRequestId - {}
 * @property {number} typeid - {1:arena; 2:test:internal}
 * @property {string} origin - {top_part; bottom_part}
 * @property {GUID} _target_id_to_uuid2 - uuid
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @return {LogObject<notInterestedInProjectInExpertDashboardParams>} LogObject<notInterestedInProjectInExpertDashboardParams>
 */
export function notInterestedInProjectInExpertDashboard(params) {
    return { evid: 99, src: 80, endpoint: 'marketplace', params: params };
}
//# sourceMappingURL=index.js.map